export const achievementData = {
    bio : "Driven by curiosity and a passion for technology, I’ve worked on impactful projects, participated in national hackathons, and continuously improved my skills in full stack development and AI. Each achievement reflects my dedication to learning, teamwork, and building real-world solutions.",
    achievements : [
        {
            id : 1,
            title : 'Smart India Hackathon 2023, Finalist',
            details : 'Our team was selected among the national finalists, showcasing innovation in healthcare tech.',
            date : 'Dec 2023',
            field : 'Hackathon',
            image : './sih2023.jpeg'
        },
        {
            id : 2,
            title : 'Trek-a-thon',
            details : 'Participated in a two-day hackathon organized by Frint.in — combining trekking, camping, and innovation.',
            date : 'Aug 2024',
            field : 'Hackathon',
            image : './trekathon.jpeg'
        },
        {
            id : 3,
            title : 'ReGen Hackathon, 1st Place (NIT Manipur)',
            details : 'Built an agricultural analytics platform using CNN, Machine Learning, and IoT.',
            date : 'May 2025',
            field : 'Hackathon',
            image : './regen.jpeg'
        },
        {
            id : 4,
            title : '1st in Competitive Programming',
            details : 'Secured 1st position in CP and 2nd in Hackathon at IIIT Manipur’s National Tech Fest AHOUBA 2024.',
            date : 'Mar 2024',
            field : 'Programming',
            image : './abouba.jpeg'
        }
    ]
}

